
import { Component, Vue } from 'vue-property-decorator';
import ToolPageHeading from '@/components/InteractiveTool/InteractiveToolComponents/ToolPageHeading.vue';
import SliderSection from '@/components/InteractiveTool/InteractiveToolComponents/SliderSection.vue';
import InstructionPopup from '@/components/InteractiveTool/InteractiveToolComponents/InstructionPopup.vue';
import AgToAg from '@/components/InteractiveTool/Arrows/AgToAg.vue';
import ClimateToWater from '@/components/InteractiveTool/Arrows/ClimateToWater.vue';
import ClimateToAg from '@/components/InteractiveTool/Arrows/ClimateToAg.vue';
import ClimateToMAndI from '@/components/InteractiveTool/Arrows/ClimateToMAndI.vue';
import GrowthToPopulation from '@/components/InteractiveTool/Arrows/GrowthToPopulation.vue';
import MandItoMandI from '@/components/InteractiveTool/Arrows/MandItoMandI.vue';
import PopToMandI from '@/components/InteractiveTool/Arrows/PopToMandI.vue';
import PopulationToAcre from '@/components/InteractiveTool/Arrows/PopulationToAcre.vue';
import AcreToAg from '@/components/InteractiveTool/Arrows/AcreToAg.vue';
import StatusCard from '@/components/InteractiveTool/InteractiveToolComponents/StatusCard.vue';
import GaugeCard from '@/components/InteractiveTool/InteractiveToolComponents/GaugeCard.vue';
import { DriverToolDataType, NodeLinkType } from '@/types';
import { VueClass } from 'vue-class-component/lib/declarations';

@Component({
  components: {
    SliderSection,
    InstructionPopup,
    AcreToAg,
    AgToAg,
    ClimateToWater,
    ClimateToAg,
    ClimateToMAndI,
    GrowthToPopulation,
    MandItoMandI,
    PopToMandI,
    PopulationToAcre,
    GaugeCard,
    StatusCard,
    ToolPageHeading,
  },
})
export default class InteractiveToolCore extends Vue {
  fullWidth = 1200;
  textSource = 'context.driversPage.pages.interactiveTool';

  driverValues: DriverToolDataType[] = require('@/assets/data/driverToolData.json');

  // slider values
  climateValue = 3;
  growthValue = 3;
  agValue = 3;
  mAndIValue = 3;

  //status card values
  water = { value: 0, active: false };
  agriculture = { value: 0, active: false };
  acreage = { value: 0, active: false };
  population = { value: 0, active: false };
  mAndI = { value: 0, active: false };

  // gauge chart values
  eAndRRiskChart = 0;
  mAndIGapChart = 0;
  agGapChart = 0;

  width = window.innerWidth;
  height = window.innerHeight;

  arrows: {
    id: string;
    categories: NodeLinkType[];
    component: VueClass<
      | AcreToAg
      | ClimateToWater
      | ClimateToAg
      | ClimateToMAndI
      | GrowthToPopulation
      | MandItoMandI
      | PopToMandI
      | PopulationToAcre
    >;
  }[] = [
    {
      id: 'AcreToAg',
      categories: ['agriculture', 'acreage'],
      component: AcreToAg,
    },
    {
      id: 'AgToAg',
      categories: ['agriculture'],
      component: AgToAg,
    },
    {
      id: 'ClimateToWater',
      categories: ['water'],
      component: ClimateToWater,
    },
    {
      id: 'ClimateToAg',
      categories: ['agriculture'],
      component: ClimateToAg,
    },
    {
      id: 'ClimateToMAndI',
      categories: ['mi'],
      component: ClimateToMAndI,
    },
    {
      id: 'GrowthToPopulation',
      categories: ['population'],
      component: GrowthToPopulation,
    },
    {
      id: 'MandItoMandI',
      categories: ['mi'],
      component: MandItoMandI,
    },
    {
      id: 'PopToMandI',
      categories: ['population', 'mi'],
      component: PopToMandI,
    },
    {
      id: 'PopulationToAcre',
      categories: ['population', 'acreage'],
      component: PopulationToAcre,
    },
  ];

  created() {
    window.addEventListener('resize', this.onResize);
  }
  destroyed() {
    window.removeEventListener('resize', this.onResize);
  }

  mounted() {
    this.updateChartValues();
  }

  onResize() {
    this.width = window.innerWidth;
    this.height = window.innerHeight;
  }

  updateChartValues() {
    const found = this.driverValues.find(
      item =>
        item.climate === this.climateValue &&
        item.economy === this.growthValue &&
        item.ag_consv == this.agValue &&
        item.mi_consv === this.mAndIValue,
    );

    if (found) {
      this.water.value = found.water;
      this.agriculture.value = found.ag_demand;
      this.acreage.value = found.acreage;
      this.population.value = found.population;
      this.mAndI.value = found.mi_demand;

      this.eAndRRiskChart = found.er_risk;
      this.mAndIGapChart = found.mi_risk;
      this.agGapChart = found.ag_risk;
    }
  }

  get activeItem(): boolean {
    return this.water.active ||
      this.agriculture.active ||
      this.acreage.active ||
      this.population.active ||
      this.mAndI.active
      ? true
      : false;
  }

  get highlightNodes(): string {
    if (this.activeItem) {
      return this.water.active
        ? 'water'
        : this.agriculture.active
        ? 'agriculture'
        : this.acreage.active
        ? 'acreage'
        : this.population.active
        ? 'population'
        : 'mi';
    } else return 'none';
  }
}
